






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { Channel } from '../interfaces';
import ChannelTags from './ChannelTags.vue';
import ChannelDescription from './ChannelDescription.vue';
import CardInfo from './card/CardInfo.vue';

@Component({
  components: {
    ChannelTags,
    ChannelDescription,
    CardInfo,
  },
})
export default class ChannelCard extends Vue {
  @Mutation('setParent') private mutationSetParent: any;

  @Prop() private channel!: Channel;
  @Prop() private parent?: string;

  private showDescription: boolean = false;
  private profileHover: boolean = false;

}
